import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { GoalBreakdown } from '../../services/morning-check-api.js';

@customElement('cp-breakdown-context')
export class CpBreakdownContext extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) parentGoals: GoalBreakdown[] = [];

  private _statusLabel(status: string): string {
    const map: Record<string, string> = {
      open: 'Offen',
      in_progress: 'In Arbeit',
      done: 'Erledigt',
      skipped: 'Uebersprungen',
    };
    return map[status] ?? status;
  }

  render() {
    if (this.parentGoals.length === 0) return nothing;

    return html`
      <div class="cp-breakdown-context">
        <h4 class="cp-breakdown-context__title">Uebergeordnete Ziele</h4>
        <div class="cp-breakdown-context__list">
          ${this.parentGoals.map(goal => html`
            <div class="cp-breakdown-context__item">
              <div class="cp-breakdown-context__item-header">
                <span class="cp-breakdown-context__item-title">${goal.title}</span>
                <span class="cp-breakdown-context__status cp-breakdown-context__status--${goal.status}">
                  ${this._statusLabel(goal.status)}
                </span>
              </div>
              ${goal.description ? html`
                <p class="cp-breakdown-context__item-description">${goal.description}</p>
              ` : nothing}
              <span class="cp-breakdown-context__priority cp-breakdown-context__priority--${goal.priority}">
                ${goal.priority}
              </span>
            </div>
          `)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-breakdown-context': CpBreakdownContext;
  }
}
